import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails, globalCountryDetailsDictionary } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  // { value: 'teu', label: 'Total TEUs'},
  // { value: 'weight', label: 'Total Weight'},
];
export const trendsDropdownOptions = [{ value: "shipments", label: "Shipments", table_header: "Total Shipments" }];
export const defaultData = {
  name: "UK Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  isFilterGroupingPresent: true,
  analyticsRangeDownloadPresent: true,
  showUiTrends: true,
  isViewAllGridNew: true,
  isUIGridNew: true,
  isUEGridNew: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2016-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [{ value: "shipments", label: "Shipments", table_header: "Total Shipments" }],
  apiEndPoints: {
    getArrivalDate: getApiUrl("ukImportLatestArrivalDate"),
    getSearchResult: getApiUrl("ukImportSearch"),
    getAnalyticsData: getApiUrl("analytics/ukImportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_uk_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_uk_imports"),
    getShipmentByID: getApiUrl("ukImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfUkImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/ukImportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.uk_import.country_small,
  countryCaps: globalCountryDetails.uk_import.country_caps,
  product_id: globalCountryDetails.uk_import.product_id,
  compare_product_id: globalCountryDetails.uk_import.compareProduct,
  country_CamelCase: globalCountryDetails.uk_import.product_id,
  countryCode: globalCountryDetails.uk_import.countryCode,
  countryShortHand: globalCountryDetails.uk_import.countryShortHand,
  countryType: globalCountryDetails.uk_import.countryType,
  manyCountryType: globalCountryDetails.uk_import.manyCountryType,
  countryTypeCode: globalCountryDetails.uk_import.countryTypeCode,
  redirectionID: globalCountryDetails.uk_import.redirectionID,
  analyticsCountryID: globalCountryDetails.uk_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Import",
  isHandleTrademoAccount: false,
  onboardingText: {
    reacttourDateRange: "Customize your shipment basis payment date",
    reacttourFilterH: "Filters Button",
    reacttourFilterP: "Use filters to get most relevant shipments for you",
    reacttourMainSearchH: "Start searching for UK Imports Shipments",
    reacttourMainSearchP: "HS Codes and Consignees",
    navTabP: "View unique importers in the search result and add them to your prospect list.",
    savedSearchButtonP: "Reload from Saved Searches, for quick shipments data access.",
  },
  picker: {
    monthPicker: true,
    datePicker: false,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: false,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: false,
    product_hscode: true,
    exporters: false,
    importers: true,
    allCategory: true,
  },
  searchCategoryList: globalCountryDetailsDictionary.uk_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    // consignee: 'consigneeName',
    // shipper: 'exporters',
    // weight: 'weight',
    // teu: 'teu',
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
  },
  filterObj: {
    consigneeName: "consigneeName",
    countryOfImportRegion: "countryOfImportRegion",
    countryOfImport: "countryOfImport",
    destinationZipcode: "destinationZipcode",
    destinationCity: "destinationCity",
    hsCode: "hsCode",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    // include_master_bill: 'include_master_bill',
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  localisationFilterObj: {
    countryOfImportRegion: "countryOfImport",
    // destinationCityRegion: "destinationCity",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
  },
  emptyFilterObj: {
    consigneeName: [],
    countryOfImportRegion: [],
    countryOfImport: [],
    destinationZipcode: [],
    destinationCity: [],
    hsCode: [],
    sections: [],
    derivedConsigneeMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    consigneeJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    // include_master_bill: true,
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    consigneeName: false,
    countryOfImportRegion: false,
    destinationZipcode: false,
    destinationCity: false,
    hsCode: false,
    sections: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    consigneeJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "16", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee", categoryName: categoryType.consigneeDetails, eventKey: "2", key: "consigneeName", type: filterType.normalFilter, label: "Consignee", viewAllPlaceHolder: "Search Consignee Name", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "countryOfImportRegion", altkey: "countryOfImport", type: filterType.localizeFilter, label: "Country Of Import", viewAllPlaceHolder: "Search Country Of Import", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee City", categoryName: categoryType.consigneeDetails, eventKey: "4", key: "destinationCity", type: filterType.normalFilter, label: "Consignee City", viewAllPlaceHolder: "Search Consignee City", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Zip Code", categoryName: categoryType.consigneeDetails, eventKey: "3", key: "destinationZipcode", type: filterType.normalFilter, label: "Consignee Zip Code", viewAllPlaceHolder: "Search Consignee Zip Code", emptyFilterText: "", searchFilterString: "", isTextCapitalise: true },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "5", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Type to Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Type to Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "5", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Type to Search HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: false, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "consignee_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Name" },
    { key: "derived_consignee_address", label: "Consignee Address" },
    { key: "destination_zipcode", label: "Consignee Zip Code" },
    { key: "derived_destination_city", label: "Consignee City" },
    { key: "hs_code", label: "HS Code" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
  ],
  shipmentSorting: [
    { columnKey: "date", value: "date", isDefault: true },
    // { columnKey: 'derived_weight', value: 'weight', isDefault: false },
    // { columnKey: 'derived_shipment_teu', value: 'teu', isDefault: false}
  ],
  exporterSorting: [
    // { columnKey: 'teu', value: 'teu', isDefault: true},
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    // { columnKey: 'weight', value: 'weight', isDefault: false }
  ],
  importerSorting: [
    // { columnKey: 'teu', value: 'teu', isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    // { columnKey: 'weight', value: 'weight', isDefault: false }
  ],
  sortKeyMap: {
    date: "date",
    // weight: 'derived_weight',
    // teu: 'derived_shipment_teu'
  },
  sortKeyUniqueImpExpMap: {
    // teu: 'teu',
    date: "doc_count",
    // weight: 'weight'
  },
  analyticsHeaderItems: [
    { label: "Total Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    // { label: 'Total TEUs', key: 'total_teu', valuePrefix: '', valueSuffix: '', },
    // { label: 'Total Shipments Weight', key: 'total_weight', valueSuffix: 'Kg', valuePrefix: '', },
  ],
  analyticsFieldsMapping: [
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_destination", filterKey: "countryOfDestination", label: "Countries of Destination", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_destination_city" },
    { key: "derived_destination_city", filterKey: "destinationCity", label: "Consignee Cities", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination" },
    { key: "hs_code", headerLabel: "HS Codes", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true },
    { key: "date", name: "Month of Import", selector: "date", dataTip: "", type: "", dateFormat: "MMM, YYYY", sortable: true },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I" },
    { key: "derived_destination_city", name: "Consignee City", selector: "derived_destination_city", dataTip: "", type: "" },
    { key: "derived_country_of_destination", name: "Country Of Destination", selector: "derived_country_of_destination", dataTip: "", type: "" },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    // { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    // { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", isCommaFormat: true },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Month of Import", value: "date", dateFormat: false, monthFormat: true },
        { label: "HS Code", value: "derived_hs_code" },
        // { label: 'Master Bill of Lading', value:'master_bol_number', capitalize:true, infoText:"A bill no. issued by shipping/carrier  companies to the freight forwarder" },
        // { label: 'House Bill of Lading', value:'house_bol_number', capitalize:true, infoText:"A bill no. issued to the shipper/exporter by the freight forwarder" },
        // { label: 'Mode of Transport', value: 'derived_is_containerised', infoText:"Mode of transportation" },
        // { label: 'HS Code', value: 'hs_code', isConditionalField: true,
        //     conditionalComponentData:[{
        //         dependentField: 'hs_codes_derived_string',
        //         mappingField: 'hs_code_description_map',
        //         infoText: 'Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.',
        //         isHSCodeFormatter: true,
        //         label: 'HS Code',
        //         isReadMore: true,
        //         readMoreLength: 65,
        //         isThunderIcon: false
        //     },
        //     {
        //         dependentField: 'derived_estimated_hs_code_is_present',
        //         mappingField: 'hs_codes_estimated_description_map',
        //         infoText: 'These HS Code(s) have been estimated based on the shipment data.',
        //         isHSCodeFormatter: true,
        //         label: 'Estimated HS Code',
        //         isReadMore: true,
        //         readMoreLength: 65,
        //         hideField: true,
        //     },
        //     {
        //         dependentField: '',
        //         mappingField: '',
        //         infoText: 'Harmonized System Code ranging from 6 to 10 digits, is an international standard to classify traded products.',
        //         isHSCodeFormatter: false,
        //         label: 'HS Code',
        //         isReadMore: false,
        //         readMoreLength: 0,
        //         isThunderIcon: false
        //     }
        // ]},
        // { label: 'Product Keywords', value:'derived_unique_product_keywords', isReadMore:true, readMoreLength:160, capitalize:true, infoText:'Product keywords derived from detailed product description on each shipment.', isProductKeywordFormater: true},
        // { label: 'Estimated Shipment Value', value:'derived_shipment_value', isThunderIcon:true, valuePrefix:"USD ", isCommaFormat:true, fixedValueUpto:2,  infoText:'Shipment Value', hideField: true, },
        // { label: 'TEU', value: 'derived_shipment_teu', isThunderIcon: true, infoText:"Twenty-feet Equivalent Unit", hideField: true,},
      ],
    },
    // {
    //     id: 2,
    //     title: "Shipment Origin Details",
    //     isConnectedColumn: true,
    //     isCompactHeader: true,
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "",
    //     data: [
    //         { label: 'Country of Origin', value: 'derived_country', countryFlag: true, countryCodeField: 'derived_country_of_origin_code' },
    //         { label: 'Shipper Name', value: 'shipper_name',},
    // { label: 'Place of Receipt', value: 'place_of_receipt', infoText: 'City or Country name in which carrier first took possessionof shipment'},
    // { label: 'Shipper Standardized Name', value: 'shipper_name', type: 'redirect', companyIdKey: 'derived_shipper_master_company_id', companyKey: '', derivedCompanyKey:'derived_shipper_master_name' },
    // { label: 'Shipper Address', value: 'derived_shipper_address',},
    // { label: 'Shipper Zip Code', value: 'zipcode',},
    // { label: 'Shipper City', value: 'derived_city',},
    // { label: 'Supplier Name', value: 'shipper_party_name', infoText: 'Name of the company exporting Shipment' },
    //     ]
    // },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Name", value: "consignee_name" },
        { label: "Consignee Standardized Name", value: "consignee_name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
        { label: "Consignee Address", value: "derived_consignee_address", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee Zip Code", value: "destination_zipcode" },
        { label: "Consignee City", value: "derived_destination_city" },
        // { label: 'Port of Unlading', value: 'derived_port_of_unlading', infoText: 'Port where the goods were unloaded from a seagoing vessel.', tooltip: true, tooltipPrefix: 'Port Code: ', tooltipField: 'port_of_unlading' },
        // { label: 'Port of Destination', value: 'derived_port_of_destination' },
        // { label: 'Foreign Port of Destination', value: 'foreign_port_of_destination' },
        // { label: 'Consignee Standardized Name', value: 'consignee_name', type: 'redirect', companyIdKey: 'derived_consignee_master_company_id', companyKey: 'consignee_name', derivedCompanyKey:'derived_consignee_master_name'  },
        // { label: 'Consignee Name', value: 'consignee_name', infoText: 'Name of the company importing Shipment', isCapitalise: true},
        // { label: 'Consignee Address', value: 'derived_consignee_full_addr', infoText: 'Address of the importing company' },
        // { label: 'Consignee City', value: 'derived_consignee_city' },
        // { label: 'Consignee State', value: 'derived_consignee_state' },
        // { label: 'Consignee Country', value: 'derived_consignee_country' },
        // { label: 'Consignee Zip Code', value: 'derived_consignee_zip_code_clean' },
        // { label: 'Notify Party Name', value: 'notify_party_name' },
        // { label: 'Notify Party Address', value: 'derived_notify_party_full_addr', infoText: 'Address of the notify party' },
        // { label: 'Secondary Notify Party', value: 'secondary_notify_party_1', isMultiFieldMapping: true, multiFieldsArr: ["secondary_notify_party_1", "secondary_notify_party_2", "secondary_notify_party_3", "secondary_notify_party_4", "secondary_notify_party_5","secondary_notify_party_6","secondary_notify_party_7","secondary_notify_party_8","secondary_notify_party_9","secondary_notify_party_10"]  },

        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    // {
    //     id: 4,
    //     title: "Carrier Details",
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     data: [
    //         { label: 'Carrier Name', value: 'derived_carrier_name', infoText: 'Carrier Name' },
    //         { label: 'Vessel Name', value: 'vessel_name', infoText: 'Name of ship used for shipment'  },
    //         { label: 'Vessel Country', value: 'vessel_country', countryFlag: true, countryCodeField: 'vessel_country_code' },
    //         { label: 'VOCC', value: 'derived_vocc_name', isThunderIcon: true, infoText: 'Vessel Operating Common Carrier', tooltip: true, tooltipPrefix: 'VOCC Code: ', tooltipField: 'derived_vocc_code', hideField: true },
    //         { label: 'NVOCC', value: 'derived_nvocc_name', isThunderIcon: true, infoText: 'Non Vessel Operating Common Carrier', tooltip: true, tooltipPrefix: 'NVOCC Code: ', tooltipField: 'derived_nvocc_code', hideField: true },
    //     ]
    // },
    // {
    //     id: 5,
    //     title: "Cargo Details",
    //     growValue: 6,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
    //     data: [
    //         { label: 'HS Code', value: 'hs_code' },
    // { label: 'Quantity', value: 'manifest_quantity', dynamicUnit: true, unitField: 'manifest_unit' },
    // { label: 'Total Weight', infoText: 'Gross weight of shipment', value: 'derived_weight', valueSuffix: ' Kg' },
    // { label: 'Container Load', value: 'derived_container_load', tooltip: true, tooltipField: 'derived_container_load_str', isCapitalise: true, },
    // ]
    // },
    // {
    //     id: 6,
    //     title: "Container Details",
    //     growValue: 12,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     isContainer: true,
    //     mainKey: 'container_details',
    //     uniqueKey: 'id',
    //     data: [
    //         {
    //             title: "Container Identifiers",
    //             titleKey: '',
    //             isNested: false,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Container Number', value: 'container_number', defaultValue: 'NA' },
    //                 { label: 'Seal Number', value: 'seal_number', defaultValue: 'NA' },
    //                 { label: 'Type of Service', value: 'type_of_service', defaultValue: 'NA' },
    //                 { label: 'Load Status', value: 'load_status', defaultValue: 'NA' },
    //                 { label: 'Marks & Numbers', value: 'marks_and_numbers', defaultValue: 'NA' },
    //                 { label: 'Equipment Desc.', value: 'equipment_description', defaultValue: 'NA' },
    //             ]
    //         },
    //         {
    //             title: "Container Dimension",
    //             titleKey: '',
    //             isNested: false,
    //             isContainerDimension: true,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Length', value: 'length', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Height', value: 'height', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Width', value: 'width', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Type', value: 'type', defaultValue: 'NA' }
    //             ]
    //         },
    //         {
    //             title: "Cargo Description",
    //             titleKey: '',
    //             isNested: true,
    //             nestedKey: "cargo_description_tables",
    //             nestedNumber: 'desc_seq_number',
    //             childData: [
    //                 { label: 'Piece Count', value: 'piece_count', defaultValue: 'NA', dynamicUnit: true, unitField: 'manifest_unit',},
    //                 { label: 'Description', value: 'cargo_description', defaultValue: 'NA', isReadMore: true, readMoreLength: 65,},
    //                 // { label: '', value: 'table', isTable: true, tableHeaderKey: ['HS Code', 'Value (USD)', 'Weight (kg)'], tableContentKey:['hscode', 'value', 'weight'] }
    //             ]
    //         },
    //         {
    //             title: "HAZMAT Sequence",
    //             titleKey: 'hazmat_sequence_number',
    //             isNested: true,
    //             nestedKey: "hazmat_sequence_tables",
    //             nestedNumber: 'hazmat_sequence_number',
    //             childData: [
    //                 { label: 'Sequence Number', value: 'hazmat_sequence_number', defaultValue: 'NA' },
    //                 { label: 'Code', value: 'hazmat_code', defaultValue: 'NA' },
    //                 { label: 'Class', value: 'hazmat_class', defaultValue: 'NA' },
    //                 { label: 'Code Qualifier', value: 'hazmat_code_qualifier', defaultValue: 'NA' },
    //                 { label: 'Contact', value: 'hazmat_contact', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp.', value: 'hazmat_flash_point_temperature', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Negative Ind', value: 'hazmat_flash_point_temperature_negative_ind', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Unit', value: 'hazmat_flash_point_temperature_unit', defaultValue: 'NA' },
    //                 { label: 'Description', value: 'hazmat_description', defaultValue: 'NA' },
    //                 { label: 'Classification', value: 'hazmat_classification', defaultValue: 'NA' },
    //             ]
    //         },
    //     ]
    // },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your shipment basis payment date", float: "", position: "left" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for UK Imports Shipments", description: "HS Codes and Consignees", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique consignees in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_destination",
  twoColumnMapping: {
    derived_consignee_master_name: "Unique Importers",
    // derived_shipper_master_name:"Unique Exporters",
    derived_country_of_destination: "Countries of Destination",
    derived_destination_city: "Consignee Cities",

    six_digit_hs_code: "6 digit HS Codes",
  },
};

const UKImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default UKImportSearch;
